// extracted by mini-css-extract-plugin
export default {"item":"TopCountries_item__22cMT","flag":"TopCountries_flag__RLWo5","price":"TopCountries_price__DXJz0"};